<template>
  <v-row
      align="center"
      justify="center"
  >
    <v-col
        cols="12"
        sm="8"
        md="6"
        lg="4"
    >
      <v-card class="elevation-12">
        <v-toolbar
            color="primary"
            dark
            flat
        >
          <v-toolbar-title class="text-center">Reset your password</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)" autocomplete="no">
            <v-card-text class="pt-6 pb-0">
              <ValidationProvider tag="div" rules="required|email" name="Email" v-slot="{ errors }">
                <v-text-field
                    label="Email"
                    outlined
                    name="email"
                    prepend-inner-icon="mdi-account"
                    type="text"
                    :error-messages="errors"
                    v-model="email"
                ></v-text-field>
              </ValidationProvider>
            </v-card-text>
            <v-card-actions>
              <v-btn block :loading="loading" color="primary" type="submit">Send password reset link</v-btn>
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
      <router-link to="/login">
        <p class="mt-4 text-center">&#8592; Back to login</p>
      </router-link>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

import {mapActions} from "vuex";
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'Home',
  title: 'Reset Password',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    loading: false,
    email: null,
  }),
  methods: {
    ...mapActions({
      resetPassword: 'auth/resetPassword',
      triggerToast: 'toast/trigger',
    }),
    onSubmit: async function() {
      this.loading = true;
      if(await this.resetPassword({email: this.email})) {
        this.triggerToast({text: 'We have emailed you a password reset link', color: "green"});
      }
      this.loading = false;
    }
  },
}
</script>